module.exports = __webpack_public_path__ + "b7dee83cb5ee2c47b053e2620f4bbb78.ttf";